import {Client} from "./client.model";

/**
 * Model reprezentujący miesięczny raport bilingowy (rozliczeniowy) dla klienta B2B.
 * Służy do podsumowania wszystkich kosztów, prowizji i opłat abonamentowych wygenerowanych
 * przez klinikę w danym miesiącu.
 */
export class MonthlyReportForClient {


  /** Globalnie unikalny identyfikator miesięcznego raportu. */
  public uuid: string;

  /** Identyfikator klienta, którego dotyczy ten raport. */
  public vClientId: number;

  /** Pełny obiekt klienta. */
  public vClient: Client;

  /** Rok, którego dotyczy rozliczenie (np. 2026). */
  public year: number;

  /** Miesiąc, którego dotyczy rozliczenie. */
  public month: number;

  /** Data utworzenia raportu w systemie. */
  public created: Date;
  public deleted: Date;


  /** Liczba aktywnych użytkowników w danym miesiącu.
   * Stanowi podstawę do wyliczenia opłaty za aktywnych użytkowników.
   */
  public activeUsers: number;

  /** Łączna kwota naliczona za aktywnych użytkowników w tym miesiącu.
   */
  public activeUsersFee: number;

  /** Łączna suma prowizji pobranych w danym miesiącu. */
  public sumOfFee: number;

  /** Suma zwrotów (Refunds) przyznanych klientowi
   */
  public refundFromVetineo: number;

  /** Całkowita, ostateczna wartość podsumowania.
   */
  public summaryValue: number;

  /** Flaga numeryczna (lub status) określająca, czy dla tego raportu
   * wymagane jest wystawienie dokumentu księgowego.
   */
  public invoiceNeeded: number;

  /** Data i czas faktycznego wysłania wygenerowanej faktury do kliniki. */
  public invoiceSent: Date;

  /** Zserializowane dane faktury (Snapshot).
   */
  public invoiceJson: string;

}
